import { api } from '../../../lib/api'

export const ADD_SUBSCRIPTION_REQUEST = 'ADD_SUBSCRIPTION_REQUEST'
export const ADD_SUBSCRIPTION_SUCCESS = 'ADD_SUBSCRIPTION_SUCCESS'
export const ADD_SUBSCRIPTION_FAILED = 'ADD_SUBSCRIPTION_FAILED'

export const addSubscription = function (currentSubscriptionId, onComplete) {
    return function (dispatch) {
        dispatch({
            type: ADD_SUBSCRIPTION_REQUEST
        })
        api.addSubscription(currentSubscriptionId).then(addSubscriptionResponse => {
            dispatch({
                type: ADD_SUBSCRIPTION_SUCCESS,
                payload: addSubscriptionResponse
            })
            if (onComplete) onComplete()
        }).catch(error => {
            dispatch({
                type: ADD_SUBSCRIPTION_FAILED,
                error
            })
        })
    }
}



// WEBPACK FOOTER //
// ./src/redux/actions/subscription/add-subscription.js